class VariantSelects extends HTMLElement {
  constructor () {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange () {
    this.updateOptions()
    this.updateMasterId()
    this.updateExternalVariants()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.updateFinance()
      this.renderProductInfo()

      window.BAO.dispatchEvent(window.BAO.EVENTS.VARIANT.CHANGED)
    }
  }

  updateOptions () {
    this.options = Array.from(
      this.querySelectorAll('select'),
      select => select.value
    )
  }

  updateMasterId () {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateExternalVariants () {
    // eslint-disable-next-line no-return-assign
    document
      .querySelectorAll('[data-variant-external-id]')
      .forEach(input => (input.value = this.currentVariant.id))
    // eslint-disable-next-line no-return-assign
    document
      .querySelectorAll('[data-variant-external-add]')
      .forEach(button => (button.disabled = !this.currentVariant.available))
  }

  updateMedia () {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )
    // eslint-disable-next-line no-useless-return
    if (!newMedia) return

    const variantIndex = window.BAO.utils
      .getElements('.prd-Media_Item')
      .findIndex(
        mediaItem =>
          mediaItem.getAttribute('data-media-id') ===
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`
      )

    // TODO: Hook up to product-media.js instead of reinitializing keenSlider
    // eslint-disable-next-line new-cap
    const gallery = new window.KeenSlider551(
      window.BAO.utils.getElement('[data-el="product-media.slides"]'),
      {
        slides: '.car-Carousel_Slide'
      }
    )

    gallery.moveToSlide(variantIndex)
  }

  updateURL () {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput () {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability () {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  updateFinance () {
    const priceMessage = window.BAO.utils.getElement(
      '.prd-Details_PriceMessage span'
    )

    if (priceMessage) {
      // eslint-disable-next-line no-extend-native
      Number.prototype.toFixedNoRounding = function (n) {
        const reg = new RegExp(`^-?\\d+(?:\\.\\d{0,${n}})?`, 'g')
        const a = this.toString().match(reg)[0]
        const dot = a.indexOf('.')
        if (dot === -1) {
          // integer, insert decimal dot and pad up zeros
          return `${a}.${'0'.repeat(n)}`
        }
        const b = n - (a.length - dot) + 1
        return b > 0 ? a + '0'.repeat(b) : a
      }

      const originalPrice = this.currentVariant.price
      const maxFinancePrice = 1500000
      let deposit = originalPrice / 10

      if (originalPrice > maxFinancePrice) {
        deposit = originalPrice - maxFinancePrice
      }

      const remainingCost = originalPrice - deposit
      const splitCost = (remainingCost / 48 / 100).toFixedNoRounding(2)

      const splitCostFormatted = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 2
      }).format(splitCost)

      priceMessage.innerHTML = splitCostFormatted
    }
  }

  renderProductInfo () {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then(response => response.text())
      .then(responseText => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        // Update sku
        const skuid = `sku-${this.dataset.section}`
        const skudestination = document.getElementById(skuid)
        const skusource = html.getElementById(skuid)

        if (skusource && skudestination) {
          skudestination.innerHTML = skusource.innerHTML
        }

        // eslint-disable-next-line no-unused-expressions
        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )
      })
  }

  toggleAddButton (disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', true)
      if (text) {
        addButton.querySelector(
          '[data-product-add-to-cart-text]'
        ).textContent = text
      }
    } else {
      addButton.removeAttribute('disabled')
      addButton.querySelector('[data-product-add-to-cart-text]').textContent =
        window.variantStrings.addToCart
    }

    // eslint-disable-next-line no-useless-return
    if (!modifyClass) return
  }

  setUnavailable () {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.querySelector('[data-product-add-to-cart-text]').textContent =
      window.variantStrings.unavailable
    // eslint-disable-next-line no-unused-expressions
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData () {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  updateOptions () {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        radio => radio.checked
      ).value
    })
  }
}

customElements.define('variant-radios', VariantRadios)
